import React from "react";
import { BuyerPayment } from "../modules/BuyerPayment";

export function BuyerPaymentPage() {
  return <BuyerPayment />;
}
